import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('jwt_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authService = {
  login: (username, password) =>
    api.post('/auth/login', { username, password }),
};

export const userService = {
  getAll: () => api.get('/dashboard/users'),
  getUserHistory: (id) => api.get(`/dashboard/users/${id}/history`),
};

export const settingsService = {
  getProfiles:   ()           => api.get('/settings/profiles'),
  createProfile: (name)       => api.post('/settings/profiles', { name }),
  renameProfile: (id, name)   => api.put(`/settings/profiles/${id}`, { name }),
  deleteProfile: (id)         => api.delete(`/settings/profiles/${id}`),
  activateProfile: (id)       => api.post(`/settings/profiles/${id}/activate`),
  getSettings:   (profileId)  => api.get(`/settings/profiles/${profileId}/settings`),
  saveSettings:  (profileId, settings) => api.put(`/settings/profiles/${profileId}/settings`, settings),
  getDefaults:   ()           => api.get('/settings/defaults'),
  sendTestMail:  (type)       => api.post(`/settings/test-mail/${type}`),
};

export const premiumService = {
  getEntries: () => api.get('/premium/entries'),
  book: (entry) => api.post('/premium/book', {
    userId:               entry.userId,
    begin:                entry.premiumBegin,
    end:                  entry.premiumEnd,
    bonusDurationSeconds: entry.bonusDurationSeconds,
    projectId:            entry.projectId,
    activityId:           entry.activityId,
  }),
  remove: (timesheetId, comment) => api.post('/premium/delete', { timesheetId, comment }),
};

export default api;
